/* @flow */

import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Link} from '../../link';
import {Avatar} from '../../avatar';
import {FormattedTimestamp} from '../../timestamp';

import './view-submission-header.css';

type Props = {
    entity: {
        type: string,
        name: string,
        htmlUrlPath: string,
        initials: string,
        avatarUrl: string,
    },
    submission: {
        time: number,
        url: string,
    },
    form: {
        name: string,
        htmlUrlPath: string,
    },
};

export function ViewSubmissionHeader(props: Props) {
    const {entity, submission, form} = props;

    return (
        <div styleName='view-submission-header'>
            <div styleName='left-container'>
                <Avatar
                    type={entity.type}
                    avatarUrl={entity.avatarUrl}
                    initials={entity.initials}
                    size={32}
                />
                <FormattedTimestamp datetime={submission.time} format={'h:mm A'} />
            </div>
            <div styleName='right-container'>
                <div>
                    <Link as={RoutedLink} variant='primary' size='small' to={entity.htmlUrlPath}>
                        {entity.name}
                    </Link>
                    {' submitted '}
                    <Link as={RoutedLink} variant='primary' size='small' to={form.htmlUrlPath}>
                        {form.name}
                    </Link>
                </div>
                <FormattedTimestamp datetime={submission.time} format={'MMMM Do, YYYY'} />
                <div styleName='submission-details-container'>
                    This form was submitted from{' '}
                    <Link variant='secondary' size='small' target='_blank' href={submission.url}>
                        {submission.url}
                    </Link>
                </div>
            </div>
        </div>
    );
}
